import {useEffect, useState} from 'react';
import { Space} from 'antd';
import cn from 'classnames';

import {Card} from '../../../components/Card/Card';
import { T2Button } from '../../../components/T2Button/T2Button';

import imgd from './hacker-photo-desktop.jpg'
import imgm from './hacker-photo-mobile.jpg'

import cls from './Cover.module.scss'

function getWindowDimensions() {
    const {innerWidth: width, innerHeight: height} = window;
    return {
        width,
        height
    };
}

export const Cover = () => {

    const [width, setWidth] = useState(getWindowDimensions().width);
    useEffect(() => {
        function handleResize() {
            setWidth(getWindowDimensions().width);
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className={cn(['content', cls.wrapper])}>

            <Card
                className={cls.cover}
                style={{backgroundImage: `url(${width >= 1024 ? imgd : imgm })`}}
                bottom={<Card
                    color={'black'}
                    className={cls.card}
                    top={
                        <Space direction={'vertical'} size={8}>
                            <h1>Помощь пострадавшим от&nbsp;мошенников</h1>
                            <div>Окажем содействие, если украли деньги со&nbsp;счета или незаконно оформили кредит</div>
                            {width > 1024 && <p><span className={cls.price}>15</span> ₽/СУТ</p>}
                            <a href={'#connect'}><T2Button block>Подключить</T2Button></a>
                        </Space>
                    }
                />
                }
            />
        </div>
    )
}